import { MagnifyingGlass } from "@phosphor-icons/react";
import { t } from "i18next";
import { useForm } from "react-hook-form";

import { useSearch } from "@/hooks";
import { RadioButtonGroup } from "@/ui";
import { tw } from "@/utils";
import { UserBundleAccessTable } from "./UserBundleAccessTable";

interface AccessUsersProps {
  selectedBundles: string[];
}

export const AccessRequests = ({ selectedBundles }: AccessUsersProps) => {
  const { searchQuery, handleSearchChange } = useSearch("");

  const { control, watch } = useForm<{
    radioOption: string[];
  }>({
    defaultValues: {
      radioOption: ["access requested"],
    },
  });
  const selectedRadioValue = watch("radioOption");

  const radioOptions = [
    { label: "Requested", value: ["access requested"] },
    { label: "All", value: ["declined", "access requested"] },
    { label: "Declined", value: ["declined"] },
  ];

  return (
    <div className="flex flex-col gap-y-6 pt-4">
      {/* Search */}
      <div className="relative flex w-full flex-row items-center sm:max-w-md">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <MagnifyingGlass
            size={20}
            className={tw(
              "text-neutral-950",
              !searchQuery && "text-neutral-500",
            )}
          />
        </div>
        <input
          type="text"
          id="search"
          placeholder={t("profile.search_placeholder")}
          value={searchQuery}
          onChange={handleSearchChange}
          className="block w-full rounded-xl border border-neutral-400 p-3 pl-10 text-sm text-neutral-950 placeholder:text-neutral-400 hover:ring-1 hover:ring-tertiary-600 focus:shadow-input focus:outline-none focus:ring-1 focus:ring-tertiary-600"
        />
      </div>

      {/* Status filter */}
      <RadioButtonGroup
        name="radioOption"
        control={control}
        items={radioOptions}
        label={
          <span className="text-xs font-semibold uppercase tracking-wide text-neutral-500">
            {t("materials.filter_by_payment_status")}
          </span>
        }
        containerClassName="flex-row flex-wrap gap-3 border-none bg-transparent p-0"
        className="flex-row gap-x-4"
      />

      <UserBundleAccessTable
        selectedBundles={selectedBundles}
        searchQuery={searchQuery}
        selectedRadioValue={selectedRadioValue}
      />
    </div>
  );
};
